import type { PixelConfig } from '../types/pixel';
import { DEFAULT_ATTRIBUTION_CONFIG } from './attribution';
import { DEFAULT_BEHAVIOR_MODULE_CONFIG } from './modules/behavior';
import { DEFAULT_CONVERSION_MODULE_CONFIG } from './modules/conversion';
import { DEFAULT_CORE_MODULE_CONFIG } from './modules/core';
import { DEFAULT_INTEGRATIONS_MODULE_CONFIG } from './modules/integrations';
import { DEFAULT_PRIVACY_MODULE_CONFIG } from './modules/privacy';
import { DEFAULT_TRANSPORT_CONFIG } from './transport';
import { DEFAULT_COMMERCE_CONFIG } from '../shared/commerce';

export const DEFAULT_PIXEL_CONFIG: PixelConfig = {
  app: {
    source: 'custom',
    target: 'custom',
    platform: '',
    environment: 'production',
    debug: false,
  },

  identity: {},

  transport: {
    ...DEFAULT_TRANSPORT_CONFIG,
    sender: { ...DEFAULT_TRANSPORT_CONFIG.sender },
    persistence: { ...DEFAULT_TRANSPORT_CONFIG.persistence },
    replay: { ...DEFAULT_TRANSPORT_CONFIG.replay },
    ordering: { ...DEFAULT_TRANSPORT_CONFIG.ordering },
    coordination: { ...DEFAULT_TRANSPORT_CONFIG.coordination },
    circuitBreaker: { ...DEFAULT_TRANSPORT_CONFIG.circuitBreaker },
    backpressure: { ...DEFAULT_TRANSPORT_CONFIG.backpressure },
    deadLetter: { ...DEFAULT_TRANSPORT_CONFIG.deadLetter },
    compression: { ...DEFAULT_TRANSPORT_CONFIG.compression },
    retry: { ...DEFAULT_TRANSPORT_CONFIG.retry },
    batch: { ...DEFAULT_TRANSPORT_CONFIG.batch },
    timeout: { ...DEFAULT_TRANSPORT_CONFIG.timeout },
    offline: { ...DEFAULT_TRANSPORT_CONFIG.offline },
    flush: { ...DEFAULT_TRANSPORT_CONFIG.flush },
  },

  storage: {
    prefix: '__gmk',
    namespace: 'pixel',

    persistence: {
      visitor: 'localStorage',
      session: 'sessionStorage',
      attribution: 'localStorage',
    },

    queue: {
      enabled: true,
      persistence: 'memory',
      index: true,
    },
  },

  attribution: { ...DEFAULT_ATTRIBUTION_CONFIG },

  commerce: {
    ...DEFAULT_COMMERCE_CONFIG,
    catalog: { products: [] },
    cart: {
      mode: 'custom',
      initialItems: [],
      allowDynamicItems: true,
      calculateValueFrom: 'cart',
    },
    mappings: { attributes: {}, fields: {} },
    enrichment: { ...DEFAULT_COMMERCE_CONFIG.enrichment },
  },

  modules: {
    core: DEFAULT_CORE_MODULE_CONFIG,
    behavior: DEFAULT_BEHAVIOR_MODULE_CONFIG,
    conversion: DEFAULT_CONVERSION_MODULE_CONFIG,
    integrations: DEFAULT_INTEGRATIONS_MODULE_CONFIG,
    privacy: DEFAULT_PRIVACY_MODULE_CONFIG,
  },
};
